import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useBooking } from "@/booking";

export const Hero = () => {
  const { openBooking } = useBooking();
  return (
    <section id="top" className="relative overflow-hidden" data-testid="hero-section">
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[720px] rounded-full bg-violet-100/50 blur-[130px]" />
      <div className="relative max-w-3xl mx-auto px-6 pt-24 pb-20 sm:pt-32 sm:pb-28 text-center">
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
          className="inline-flex items-center rounded-full border border-[#E9E4F0] bg-[#FFFFFF] px-4 py-1.5 text-xs font-semibold text-violet-300"
          data-testid="hero-eyebrow"
        >
          B2B lead generation · IT recruitment
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, delay: 0.1 }}
          className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-[#3B0764]"
          data-testid="hero-title"
        >
          Book 10+ qualified sales meetings{" "}
          <span className="text-violet-700">every month</span> for your recruitment firm.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, delay: 0.2 }}
          className="mt-6 text-base sm:text-lg leading-relaxed text-[#6B5CA5]"
          data-testid="hero-subtitle"
        >
          We connect IT recruitment firms with companies actively hiring top tech talent — through
          targeted LinkedIn outreach and cold email that books qualified sales meetings on repeat.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <button
            onClick={openBooking}
            data-testid="hero-book-audit-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-violet-700 px-7 py-4 text-base font-semibold text-white transition-[background-color,transform] duration-300 hover:bg-violet-600 hover:scale-[1.02] active:scale-[0.98]"
          >
            Book a Free Audit
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <a
            href="#how"
            data-testid="hero-view-methodology-cta"
            className="inline-flex items-center gap-2 rounded-full border border-[#E9E4F0] bg-[#FFFFFF] px-7 py-4 text-base font-semibold text-[#3B0764] transition-[border-color,color] duration-300 hover:border-violet-500 hover:text-violet-300"
          >
            View Methodology
          </a>
        </motion.div>
      </div>
    </section>
  );
};
